export default __webpack_public_path__ + "static/hero-fd7dd6de8b9b2e88ac13e4afcc572a72.png";